import React from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { useIsGuest } from './GuestProvider';

const hideFavorites = `
[id^="favorite-"],
[title="Add to favorites"],
[title="Remove from favorites"],
[aria-label="Add to favorites"],
[aria-label="Remove from favorites"] {
  display: none !important;
}
`;

const hideEntityHeaderItems = `
header div:has(> span > p + * a[href*="/group/"], > span > p + * a[href*="/user/"]) {
  display: none;
}
header [data-testid="menu-button"] {
  display: none;
}
`;

export const GuestHiddenElementsStyles = () => {
  const isGuest = useIsGuest();
  const { pathname } = useLocation();
  const isEntityPage = !!matchPath(
    '/catalog/:namespace/:kind/:name/*',
    pathname,
  );

  if (!isGuest) {
    return null;
  }

  return (
    <style>
      {hideFavorites}
      {isEntityPage && hideEntityHeaderItems}
    </style>
  );
};
